import Icon from '../components/Icon.vue'

Icon.register({"music":{"width":512,"height":512,"paths":[{"d":"M512 32C512 10.3 490.9-5 470.4 1.5L150.4 96C137.1 100.2 128 112.5 128 126.5V387.9C118 385.5 107.3 384 96 384 43 384 0 412.6 0 448S43 512 96 512 192 483.4 192 448V214.3L448 139.3V323.9C437.9 321.5 427.3 320 416 320 363 320 320 348.6 320 384S363 448 416 448 512 419.4 512 384L512 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/music.js
// module id = null
// module chunks = 